var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.subtitle)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }